import React, { Component } from "react";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-kit-react/views/docPage.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import Typography from "@material-ui/core/Typography";
import Button from "components/CustomButtons/Button.jsx";
import DocListItem from "components/DocList/DocListItem";
import GlobalValue from "GlobalValue";
import axios from "axios";
import EmpList from "views/DocPage/Modal/EmpList.jsx";

import SaveAlt from "@material-ui/icons/SaveAlt";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Dropzone from "react-dropzone";
import {
  insertEdocument,
  btoa,
  _callApiMessage,
  _parceDate
} from "GlobalFunction";

// core components
function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const Today = new Date();
const TodayYear = Today.getFullYear();
const TodayMonth = Today.getMonth() + 1;
const TodayDay = Today.getDate();
const NowHour = Today.getHours();
const NowMin = Today.getMinutes();
const NowSec = Today.getSeconds();
const NowMSec = Today.getMilliseconds();
class E_Doc00 extends Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      openEmpList: false,
      EJSignGubun: 0,
      EJText: "",
      fileList: [],
      showEmpList: true,
      EJSTCode: "",
      EJOpenDateTime: `${TodayYear}-${TodayMonth}-${TodayDay} ${NowHour}:${NowSec}`
    };
  }
  handleChange = e => {
    let nextState = {};
    nextState[e.target.name] = e.target.value;

    this.setState(nextState);
  };
  handleClose = () => {
    this.props.handleEdocClose();
  };

  addEmp = emp => {
    this.setState({
      showEmpList: true,
      checkedEmp: emp,
      EJSTCode: emp.STCode
    });
  };

  _checkedItem = (value, text) => {
    if (value === undefined || value === "" || value === null) {
      alert(`${text} 을 확인하여 주세요`);
      return false;
    }
    return true;
  };
  componentDidMount() {}

  handleFileChange = e => {
    // console.log(e.target.value);
    // console.log(e.target.files);
    // console.log(e.target.files[0].webkitRelativePath);
    this.setState({ fileList: e.target.files, fileUrl: e.target.value });
  };

  handleEmpList = () => {
    this.setState({ showEmpList: false });
  };
  downloadFile = item => {
    // console.log("click", item);
    var docUrl = "http://14.63.172.72:8080/DP4/EDocument/";
    // var docUrl = "http://linepayroll.iptime.org:8080/DP4/EDocument/";
    var filePath = `${GlobalValue.USER_INFO.SCDBName}/${item.EDDateTime.substr(
      0,
      10
    )}${item.EDDateTime.substr(11, 8)}_${item.EDMilliSecond}_${
      item.EFAddSTCode
    }${item.EFSeq + 1}`;
    var ext = this.extention(item.EFPath);
    ext = "." + ext[0];
    // const proxyurl = "https://cors-anywhere.herokuapp.com/";
    // var url = proxyurl + docUrl + filePath + ext;
    var url = docUrl + filePath + ext;
    window.open(url);
    // var fileDownload = require("react-file-download");
    // fileDownload(url, item.EFPath);
    // axios({
    //   url: url,
    //   method: "GET",
    //   responseType: "blob" // important
    // }).then(response => {
    //   console.log("fileDown", response);
    //   const url = window.URL.createObjectURL(new Blob([response.data]));
    //   const link = document.createElement("a");
    //   link.href = url;
    //   link.setAttribute("download", item.EFPath);
    //   document.body.appendChild(link);
    //   link.click();
    // });
  };

  extention(filename) {
    return /[.]/.exec(filename) ? /[^.]+$/.exec(filename) : undefined;
  }
  handleEdocEmpListClose = () => {
    this.setState({ openEmpList: false });
  };
  handleSubmit = async () => {
    if (this.props.gubun === 1) {
      this.handleClose();
      return;
    }
    if (this.state.EJSignGubun === 0) {
      alert("결재구분을 선택하세요");
      return;
    }
    const formData = new FormData();
    const filelist = this.state.fileList;
    if (this.state.fileList.length > 0) {
      for (var i = 0; i < filelist.length; i++) {
        var filenameBase64 = btoa(
          encodeURIComponent(filelist[i].name).replace(
            /%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
              return String.fromCharCode("0x" + p1);
            }
          )
        );
        formData.append("upload", filelist[i], filenameBase64);
      }
    }

    var dbinfo = {
      SCDBName: GlobalValue.USER_INFO.SCDBName,
      SCHostIp: GlobalValue.USER_INFO.SCHostIp
    };
    var tempInsertData = insertEdocument;
    tempInsertData.EDDateTime = this.props.item.EDDateTime.split(".")[0];
    tempInsertData.EDMilliSecond = this.props.item.EDMilliSecond;
    tempInsertData.EDEJSeq = this.props.item.EDEJSeq + 1;
    tempInsertData.EJSignGubun = this.state.EJSignGubun;
    tempInsertData.EJBefJoinSTCode = this.props.item.EDSTCode; //업무요청은 직전기안자는 최초기안자
    tempInsertData.EDSTCode = this.props.item.EDSTCode; // 최초기안자
    tempInsertData.EJOpenDateTime = this.state.EJOpenDateTime; // 오픈 날짜
    tempInsertData.EJText = this.state.EJText; // 의견
    tempInsertData.EJSignGubun = this.state.EJSignGubun;

    tempInsertData.EJAftJoinSTCode = GlobalValue.USER_INFO.SUSTCode; // 최종일땐 내가 마지막
    tempInsertData.EJSTCode = GlobalValue.USER_INFO.SUSTCode;
    // tempInsertData.EJBefJoinSTCode = this.props.EDoc[
    //   this.props.EDoc.length - 1
    // ].EJBefJoinSTCode; //직전결제자는 나
    tempInsertData.EDLastJoinYN = "Y";

    formData.append("EDocObj", JSON.stringify(tempInsertData));
    formData.append("DBInfo", JSON.stringify(dbinfo));
    // console.log("formData", tempInsertData);
    axios
      .post(GlobalValue.BASE_URL + "e-doc/new", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data;charset=UTF-8"
        }
      })
      .then(response => {
        // console.log("response", response);
        if (response.status === 200) {
          return response.data;
        } else {
          alert("systemError.. 관리자에게 문의하세요..");
        }
      })
      .then(responseBody => {
        if (responseBody.code === "00") {
          if (responseBody.type === "O") {
            // Navigation.pop("DOC_TAB_STACK");
            // PUSH 전송
            var EJSignGubunTxt = GlobalValue.EJSignGubun_1.filter(
              item => item.value === this.state.EJSignGubun
            )[0].name;
            var pushBody = `등록하신 '${
              this.props.EDoc[0].EDTitle
            }'이(가) ${EJSignGubunTxt} 되었습니다.`;
            var fcmData = {
              title: "업무 요청",
              body: pushBody,
              data: {
                DATA_KEY: "02",
                DATA_GUBUN: "REF"
              }
            };
            //참조자들에게 푸시
            if (this.props.ERef.length > 0) {
              var body = `userList=${JSON.stringify(
                this.props.ERef
              )}&fcmData=${JSON.stringify(fcmData)}`;
              _callApiMessage("fcm/send/multi", body).then(responsBody => {
                // console.log("fcm/send/multi", responsBody);
              });
            }

            fcmData = {
              title: "업무 요청",
              body: this.props.EDoc[0].EDTitle,
              data: {
                DATA_KEY: "02",
                DATA_GUBUN: "OLD"
              }
            };

            // 업무요청은 최초기안자에게만 보내주도록
            var body = `SUSCCode=${GlobalValue.USER_INFO.SCCode}&SUSTCode=${
              this.props.EDoc[0].EDSTCode
            }&fcmData=${JSON.stringify(fcmData)}`;
            // console.log("결재권자 바디", body);
            _callApiMessage("fcm/send", body).then(responsBody => {
              // console.log("fcm/send", responsBody);
            });

            alert("전자 발송 하였습니다.");
            this.handleClose();
          } else {
            if (responseBody.code === "20") {
              alert(
                "에러코드 20(파일업로드)" +
                  "시스템에러.. 관리자에게 문의하세요.."
              );
            }
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  onPreviewDrop = files => {
    this.setState({
      fileList: this.state.fileList.concat(files)
    });
  };
  onPreviewPop = async index => {
    let sliceFile = this.state.fileList;
    sliceFile.splice(index, 1);
    await this.setState({ fileList: sliceFile });
  };
  render() {
    const { classes, EDoc, EFile, firstList, ...rest } = this.props;
    const firstEDoc = firstList.firstEDoc;
    const FIRSTFILEDATA = firstList.firstEFile;
    // console.log("eg1", this.props);
    return (
      <div>
        <Dialog
          maxWidth="lg"
          open={this.props.openDialog}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          {this.state.showEmpList ? (
            <div>
              <DialogTitle id="alert-dialog-slide-title">{"내용"}</DialogTitle>
              {firstEDoc ? (
                <div>
                  <DialogContent>
                    <DocListItem title="제목" memo={firstEDoc[0].EDTitle} />{" "}
                    <DocListItem title="기안자" memo={firstEDoc[0].EDSTNAME} />
                    <DocListItem
                      title="구분"
                      memo={
                        GlobalValue.EG1Code_1.filter(item => {
                          return item.value === firstEDoc[0].EDEG1Code;
                        })[0].name
                      }
                    />
                    <DocListItem
                      title="기안일"
                      memo={firstEDoc[0].EDDateTime.split(".")[0]}
                    />
                    <DocListItem
                      title="문서 번호"
                      memo={firstEDoc[0].EDNumber}
                    />
                    <DocListItem title="내용" memo={firstEDoc[0].EDText} />
                    {FIRSTFILEDATA
                      ? FIRSTFILEDATA.map((item, index) => {
                          return (
                            <DocListItem
                              title={`첨부 파일 ${index + 1}`}
                              key={index}
                            >
                              <SaveAlt className={classes.docItemFileimg} />
                              <label
                                className={classes.docItemFileLabel}
                                onClick={() => this.downloadFile(item)}
                              >
                                {item.EFPath.length > 40
                                  ? `${item.EFPath.substr(0, 40)} ...`
                                  : item.EFPath}
                              </label>
                            </DocListItem>
                          );
                        })
                      : null}
                    <DocListItem title="비고" memo={firstEDoc[0].EDBigo} />
                  </DialogContent>
                  {EDoc.filter(
                    item => item.EJSeq !== 0 && item.EJSignGubun !== 8
                  ).map((item, index) => {
                    const tempFileList = EFile.filter(
                      v =>
                        v.EJSeq !== 0 && v.EFAddSTCode === item.EJBefJoinSTCode
                    );
                    return (
                      <div key={index}>
                        <DialogTitle id="alert-dialog-slide-title">
                          {"결재"}
                        </DialogTitle>
                        <DialogContent>
                          <DocListItem
                            title={`결재자 ${index + 1}`}
                            memo={`${item.EJAFTJOINSTNAME}`}
                          />{" "}
                          <DocListItem
                            title="결재자 의견"
                            memo={`${item.EJText}`}
                          />
                          {this.props.EFile
                            ? this.props.EFile.filter(
                                f => f.EFEJSeq === item.EJSeq
                              ).map((ff, index) => {
                                return (
                                  <DocListItem
                                    title={`첨부 파일 ${index + 1}`}
                                    key={index}
                                  >
                                    <SaveAlt
                                      className={classes.docItemFileimg}
                                    />
                                    <label
                                      className={classes.docItemFileLabel}
                                      onClick={() => this.downloadFile(ff)}
                                    >
                                      {ff.EFPath.length > 40
                                        ? `${ff.EFPath.substr(0, 40)} ...`
                                        : ff.EFPath}
                                    </label>
                                  </DocListItem>
                                );
                              })
                            : null}
                        </DialogContent>
                      </div>
                    );
                  })}

                  {this.props.gubun === 1 || this.props.gubun === 3 ? (
                    <div>
                      <DialogTitle id="alert-dialog-slide-title">
                        {"결재 처리"}
                      </DialogTitle>
                      <DialogContent>
                        <DocListItem
                          title="결재자"
                          memo={EDoc[EDoc.length - 1].EJAFTJOINSTNAME}
                        />
                        <DocListItem
                          title="결재자 의견"
                          memo={
                            EDoc[EDoc.length - 1].EJSignGubun === 8 &&
                            EDoc[EDoc.length - 1].EJText
                          }
                        />
                        {this.props.EFile
                          ? this.props.EFile.filter(
                              f =>
                                f.EFEJSeq === EDoc[EDoc.length - 1].EJSeq &&
                                EDoc[EDoc.length - 1].EJSignGubun === 8
                            ).map((item, index) => {
                              return (
                                <DocListItem
                                  title={`첨부 파일 ${index + 1}`}
                                  key={index}
                                >
                                  <SaveAlt className={classes.docItemFileimg} />
                                  <label
                                    className={classes.docItemFileLabel}
                                    onClick={() => this.downloadFile(item)}
                                  >
                                    {item.EFPath.length > 40
                                      ? `${item.EFPath.substr(0, 40)} ...`
                                      : item.EFPath}
                                  </label>
                                </DocListItem>
                              );
                            })
                          : null}
                      </DialogContent>
                    </div>
                  ) : (
                    <div>
                      <DialogTitle id="alert-dialog-slide-title">
                        {"결재 처리"}
                      </DialogTitle>
                      <DialogContent>
                        <DocListItem title="결재구분">
                          <Select
                            value={this.state.EJSignGubun}
                            onChange={this.handleChange}
                            inputProps={{
                              name: "EJSignGubun",
                              id: "age-simple"
                            }}
                          >
                            {GlobalValue.EJSignGubun_1.map((item, index) => {
                              return (
                                <MenuItem value={item.value} key={index}>
                                  {item.name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </DocListItem>
                        <DocListItem title="의견">
                          <input
                            type="text"
                            // placeholder="제목을 입력해주세요."
                            size="60"
                            className={classes.docInputText}
                            value={this.state.EJText}
                            onChange={this.handleChange}
                            name="EJText"
                          />
                        </DocListItem>
                        <DocListItem title="첨부파일" height="100px">
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Dropzone
                              onDrop={acceptedFiles =>
                                this.onPreviewDrop(acceptedFiles)
                              }
                            >
                              {({ getRootProps, getInputProps }) => (
                                <section>
                                  <div
                                    {...getRootProps()}
                                    style={{
                                      height: "50px",
                                      border: "1px solid",
                                      borderStyle: "dotted"
                                    }}
                                  >
                                    <input {...getInputProps()} />
                                    <p>
                                      파일 드래그 또는 클릭하여 삽입해주세요.
                                    </p>
                                  </div>
                                </section>
                              )}
                            </Dropzone>
                            {this.state.fileList.length > 0 && (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  overflow: "auto",
                                  height: "50px"
                                }}
                              >
                                <ul>
                                  {this.state.fileList.map((file, index) => (
                                    <li key={index + 100}>
                                      <label key={index + 100}>
                                        {file.name}
                                      </label>
                                      <label
                                        type="none"
                                        onClick={() => this.onPreviewPop(index)}
                                        style={{ backgroundColor: "#d1d1d1" }}
                                      >
                                        삭제
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                        </DocListItem>
                        {/* <DocListItem title="첨부 파일">
                          <input
                            type="file"
                            onChange={this.handleFileChange}
                            multiple
                          />
                          <label>최대 5개</label>
                        </DocListItem> */}
                        {this.state.EJSignGubun === 4 && (
                          <DocListItem title="결재자">
                            <Button onClick={this.handleEmpList} color="submit">
                              {this.state.checkedEmp
                                ? this.state.checkedEmp.STNameKor
                                : "결재자 선택"}
                            </Button>
                          </DocListItem>
                        )}
                      </DialogContent>
                    </div>
                  )}
                </div>
              ) : null}

              {this.props.gubun === 1 || this.props.gubun === 3 ? (
                <DialogActions>
                  <Button onClick={this.handleClose} color="cancel">
                    닫기
                  </Button>
                </DialogActions>
              ) : (
                <DialogActions>
                  <Button onClick={this.handleClose} color="cancel">
                    취소
                  </Button>
                  <Button onClick={this.handleSubmit} color="submit">
                    확인
                  </Button>
                </DialogActions>
              )}
            </div>
          ) : (
            <EmpList
              openDialog={this.state.openEmpList}
              handleEdocEmpListClose={this.handleEdocEmpListClose}
              addEmp={this.addEmp}
            />
          )}
        </Dialog>
      </div>
    );
  }
}

E_Doc00.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(E_Doc00);
